<div class="infor" *ngIf="InstagramInfo">
    <p class="instagram"><a href="https://www.instagram.com/bill_yin/" target="new">
        <span class="icon"><img src="{{InstagramInfo}}" alt="Bill's instagram"></span>
        Instagram</a>
    </p>
</div>
<div class="instagram-post" *ngIf="InstagramPost">
    <div class="row">
        <div class="col-lg-3 col-xs-6 col-md-3 col-sm-6 item"  *ngFor="let media of InstagramPost">
            <div class="card">
                <div class="card-image">
                    <a href="{{media.link}}" target="new">
                        <img src="{{media.images.thumbnail.url}}" class="card-img-top" alt="{{media.location.name}}">
                    </a>                    
                </div>
                <div class="card-body">
                    <div class="body-wrapper">                                
                    <div class="siteTitle">
                        <span>{{media.location.name}}</span>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</div>